import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { agencyApi } from "./agencyApi";
import { StatusPill, when, isDelivered, stageChipLabel } from "./AgencyBits";

export default function AgencyProjects() {
  const nav = useNavigate();
  const [projects, setProjects] = useState(null);
  const [err, setErr] = useState(false);

  const load = () => {
    setErr(false);
    agencyApi.myProjects().then((r) => setProjects(r.data.projects || [])).catch(() => setErr(true));
  };
  useEffect(() => { load(); }, []); // eslint-disable-line

  if (err) {
    return (
      <div className="ag-empty" data-testid="agency-projects-error">
        We couldn't load your projects.
        <div style={{ marginTop: 12 }}>
          <button className="ag-btn ag-btn-ghost" onClick={load} data-testid="agency-projects-retry">Try again</button>
        </div>
      </div>
    );
  }
  if (!projects) return <div className="ag-small">Loading…</div>;

  const delivered = projects.filter((p) => isDelivered(p.status));
  const active = projects.filter((p) => !isDelivered(p.status));

  return (
    <div data-testid="agency-projects">
      <h1 className="ag-h1 ag-entrance" style={{ fontSize: 36, marginBottom: 28 }}>Projects</h1>
      {projects.length === 0 ? (
        <div className="ag-empty">No projects yet. Your projects appear here once NJM sets them up.</div>
      ) : (
        <>
          {active.length > 0 && (
            <div className="ag-grid ag-grid-2 ag-entrance-2">
              {active.map((p) => (
                <button key={p.id} className="ag-card ag-card-hover" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", textAlign: "left" }}
                  onClick={() => nav(`/agency/projects/${p.id}`)} data-testid="agency-projects-item">
                  <div>
                    <div className="ag-h3" style={{ marginBottom: 8 }}>{p.name}</div>
                    <StatusPill status={stageChipLabel(p.status, p.lost)} />
                  </div>
                  <ArrowRight size={20} color="#8A8A8A" />
                </button>
              ))}
            </div>
          )}

          {delivered.length > 0 && (
            <section className="ag-delivered-section" data-testid="agency-projects-delivered">
              <h2 className="ag-eyebrow" style={{ marginBottom: 16 }}>Delivered</h2>
              {delivered.map((p) => (
                <div key={p.id} className="ag-delivered-row" data-testid="agency-delivered-row">
                  <div className="ag-h3" style={{ fontSize: 15 }}>{p.name}</div>
                  <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                    <StatusPill status={stageChipLabel(p.status, p.lost)} />
                    <button className="ag-link" onClick={() => nav(`/agency/projects/${p.id}`)} data-testid="agency-delivered-view">VIEW →</button>
                  </div>
                </div>
              ))}
            </section>
          )}
        </>
      )}
    </div>
  );
}
